import { BASE_WIDTH, DRAGGABLE_COL_WIDTH } from "./config";

export var getColWidth = (colsCount, isDraggable) =>
  isDraggable ? DRAGGABLE_COL_WIDTH : Math.floor(BASE_WIDTH / colsCount);
